import { render } from "./StatsCards.vue?vue&type=template&id=249ba4e4"
import script from "./StatsCards.vue?vue&type=script&lang=js"
export * from "./StatsCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__